import {
  Alert,
  Box,
  Button,
  Grid,
  TextField,
  Typography,
  Paper,
  LinearProgress,
  Tabs,
  Tab,
} from "@mui/material";
import YouTubeIcon from "@mui/icons-material/YouTube";
import SaveIcon from "@mui/icons-material/Save";
import { useEffect, useState } from "react";
import usePostData from "../../../utility/usePostData";
import ListeYoutubeVideo from "./ListeYoutubeVideo";
import { FileUpload } from "@mui/icons-material";

const CreateSlideForm = () => {
  const { response, isLoading, error, submitData } = usePostData();
  const [youtube_title, setYouTubeTitle] = useState("");
  const [youtube_media, setYouTubeMedia] = useState("");
  const [response_message, setResponseMessage] = useState("");
  const [tabValue, setTabValue] = useState(0);
  
  // États pour l'upload de fichier
  const [videoTitle, setVideoTitle] = useState("");
  const [selectedVideoFile, setSelectedVideoFile] = useState(null);

  useEffect(() => {
    if (response?.data) {
      setResponseMessage(response?.data.data);
      // Réinitialiser les champs après succès
      setYouTubeTitle("");
      setYouTubeMedia("");
      setVideoTitle("");
      setSelectedVideoFile(null);
    }
    return {};
  }, [response]);

  const sendData = (e) => {
    e.preventDefault();
    const media = {
      youtube_title: youtube_title,
      youtube_media: youtube_media,
    };
    submitData("youtube_medias", media);
  };

  const uploadVideoFile = (e) => {
    e.preventDefault();
    if (!selectedVideoFile || !videoTitle) {
      alert("Veuillez remplir tous les champs");
      return;
    }

    const formData = new FormData();
    formData.append("file", selectedVideoFile);
    formData.append("title", videoTitle);
    
    // Ajustez l'endpoint selon votre API
    submitData("video-files", formData);
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  

  return (
    <Box sx={{ width: "95%", margin: "auto", mt: 3 }}>
      <Paper elevation={2} sx={{ p: 3 }}>
        <Typography
          variant="h5"
          sx={{
            color: "#00a652",
            mb: 4,
            fontWeight: 500,
            borderBottom: "2px solid #00a652",
            paddingBottom: 1,
            display: "inline-block",
          }}
        >
          Gestion des Vidéos
        </Typography>

        <Grid container spacing={3}>
          <Grid item xs={12} md={4}>
            <Paper
              elevation={0}
              sx={{
                p: 3,
                backgroundColor: "rgba(0,166,82,0.04)",
                border: "1px solid rgba(0,166,82,0.2)",
                borderRadius: 2,
              }}
            >
              <Tabs
                value={tabValue}
                onChange={handleTabChange}
                sx={{
                  mb: 3,
                  "& .MuiTab-root": {
                    color: "#666",
                    "&.Mui-selected": {
                      color: "#00a652",
                    },
                  },
                  "& .MuiTabs-indicator": {
                    backgroundColor: "#00a652",
                  },
                }}
              >
                <Tab label="YouTube" icon={<YouTubeIcon />} />
                <Tab label="Upload Fichier" icon={<FileUpload />} />
              </Tabs>

              {response && (
                <Alert severity="success" sx={{ mb: 2 }}>
                  {response_message}
                </Alert>
              )}

              {/* Formulaire YouTube */}
              {tabValue === 0 && (
                <>
                  <Typography
                    variant="h6"
                    sx={{
                      color: "#00a652",
                      mb: 3,
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                    }}
                  >
                    <YouTubeIcon /> Ajouter une Vidéo YouTube
                  </Typography>

                  <form onSubmit={sendData}>
                    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                      <TextField
                        fullWidth
                        size="small"
                        type="text"
                        value={youtube_title}
                        onChange={(e) => setYouTubeTitle(e.target.value)}
                        label="Titre de la vidéo"
                        required
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            "&:hover fieldset": {
                              borderColor: "#00a652",
                            },
                            "&.Mui-focused fieldset": {
                              borderColor: "#00a652",
                            },
                          },
                        }}
                      />

                      <TextField
                        fullWidth
                        size="small"
                        type="text"
                        value={youtube_media}
                        label="ID de la vidéo YouTube"
                        required
                        onChange={(e) => setYouTubeMedia(e.target.value)}
                        helperText="Ex: dQw4w9WgXcQ (extrait de l'URL)"
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            "&:hover fieldset": {
                              borderColor: "#00a652",
                            },
                            "&.Mui-focused fieldset": {
                              borderColor: "#00a652",
                            },
                          },
                        }}
                      />

                      <Button
                        type="submit"
                        variant="contained"
                        startIcon={<SaveIcon />}
                        sx={{
                          backgroundColor: "#00a652",
                          "&:hover": { backgroundColor: "#008c46" },
                          alignSelf: "flex-start",
                        }}
                      >
                        Enregistrer
                      </Button>
                    </Box>
                  </form>
                </>
              )}

              {/* Formulaire Upload Fichier */}
              {tabValue === 1 && (
                <>
                  <Typography
                    variant="h6"
                    sx={{
                      color: "#00a652",
                      mb: 3,
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                    }}
                  >
                    <FileUpload /> Uploader une Vidéo
                  </Typography>

                  <form onSubmit={uploadVideoFile}>
                    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                      <TextField
                        fullWidth
                        size="small"
                        type="text"
                        value={videoTitle}
                        onChange={(e) => setVideoTitle(e.target.value)}
                        label="Titre de la vidéo"
                        required
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            "&:hover fieldset": {
                              borderColor: "#00a652",
                            },
                            "&.Mui-focused fieldset": {
                              borderColor: "#00a652",
                            },
                          },
                        }}
                      />

                      <Button
                        variant="outlined"
                        component="label"
                        fullWidth
                        startIcon={<FileUpload />}
                        sx={{
                          color: "#00a652",
                          borderColor: "#00a652",
                          "&:hover": {
                            backgroundColor: "rgba(0,166,82,0.04)",
                            borderColor: "#00a652",
                          },
                          textTransform: "none",
                          padding: "10px",
                          justifyContent: "flex-start",
                        }}
                      >
                        {selectedVideoFile 
                          ? selectedVideoFile.name 
                          : "Choisir un fichier vidéo"}
                        <input
                          type="file"
                          hidden
                          accept="video/*"
                          onChange={(e) => setSelectedVideoFile(e.target.files[0])}
                          required
                        />
                      </Button>

                      {selectedVideoFile && (
                        <Typography variant="caption" color="text.secondary">
                          Taille: {(selectedVideoFile.size / (1024 * 1024)).toFixed(2)} MB
                        </Typography>
                      )}

                      <Button
                        type="submit"
                        variant="contained"
                        startIcon={<FileUpload />}
                        sx={{
                          backgroundColor: "#00a652",
                          "&:hover": { backgroundColor: "#008c46" },
                          alignSelf: "flex-start",
                        }}
                      >
                        Uploader
                      </Button>
                    </Box>
                  </form>
                </>
              )}

              {isLoading && (
                <LinearProgress
                  sx={{
                    mt: 2,
                    backgroundColor: "#e0e0e0",
                    "& .MuiLinearProgress-bar": {
                      backgroundColor: "#00a652",
                    },
                  }}
                />
              )}

              {error && (
                <Alert severity="error" sx={{ mt: 2 }}>
                  Les données saisies sont incorrectes
                </Alert>
              )}
            </Paper>
          </Grid>

          <Grid item xs={12}>
            <ListeYoutubeVideo />
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
};

export default CreateSlideForm;